import { UPDATE_SORT_DATA } from '../type';
export const updateSortData = (sortData) => ({
  type: UPDATE_SORT_DATA,
  payload: sortData,
});
